module.exports = __webpack_public_path__ + "static/media/UA.056feff1.svg";